export default __webpack_public_path__ + "static/media/root-margin.486f3e55.gif";